import { field, validate } from '@balance-web/forms';

import { Step } from './types';

export const formSchema = (step: Step) =>
  field.object({
    emailOrUsername: field.text({
      validate: validate((value) => {
        validate.required(value);
        if (value.includes('@')) validate.email(value);
        return value;
      }),
    }),
    password: field.text({
      validate: validate((value) => {
        if (step === 'login') {
          validate.required(value);
        }

        return value;
      }),
    }),
  });
